export const GROWUP_REPORT_TYPE = {
  WEEK: 'week',
  MONTH: 'month',
} as const;

export type GrowupReportType = typeof GROWUP_REPORT_TYPE[keyof typeof GROWUP_REPORT_TYPE];

export const GROWUP_REPORT_NAME_MAP = {
  [GROWUP_REPORT_TYPE.WEEK]: '周',
  [GROWUP_REPORT_TYPE.MONTH]: '月',
} as const;
